export default {
  zh: {
    dear: 'Dear user',
    welcome:
      'Welcome to the Host System, through which you can receive corresponding cash rewards. The rules are as follows:',
    ruleContent: `
    1: In order to activate a host agency, the number of hosts to be registered must be no less than 15 hosts ( The number can be more, but it cannot be less ) <br/>
    2: Money is earned by receiving Rubies gifts<br>
    3: the ruby ​​gifts result in diamonds that can be exchanged for coins.  The host can also withdraw rubies from his points to use them in the ruby ​​wallet, and this has an impact on his points<br/>
    4: The Target is completed at the end of each month and the beginning of a new Target with a new month, the money is sent to the agencies on the 10th of each month<br/>
    5: The host agencies are received via App WhatsApp to send all the information required for registration at the beginning of each month`,
    desc1:
      'Cash rewards will be canceled for the following accounts: refunds after recharging, and cheating by one user using multiple fake accounts',
    desc2: '',
    tips: 'Notice',
    wait: 'Pending review',
    waitc: 'Please be patient and follow the application progress at any time',
    suc: 'Successful application',
    sucC: 'Congratulations on becoming a member of the host system program. You will be able to withdraw rubies.',
    fail: 'Application failed',
    failC: 'We are very sorry that your host system application failed for the following reasons:',
    apply: 'Apply',
    rapply: 'Re-apply',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'area number: +44', //me
    phomeNumber: 'phome number: 13650820118', //me,
    welcomeText: `Welcom to`,
    hostsystem: 'Host System',
    findanAgency: 'Find an Agency',
    createanAgency: 'Create an Agency',
    findText: 'Find and apply to join a Agency to become a Host',
    craeteText: 'Apply to create an Agency and invite others to join'
  },
  en: {
    dear: 'Dear user',
    welcome:
      'Welcome to the Host System, through which you can receive corresponding cash rewards. The rules are as follows:',
    ruleContent: `
    1: In order to activate a host agency, the number of hosts to be registered must be no less than 15 hosts ( The number can be more, but it cannot be less ) <br/>
    2: Money is earned by receiving Rubies gifts<br>
    3: the ruby ​​gifts result in diamonds that can be exchanged for coins.  The host can also withdraw rubies from his points to use them in the ruby ​​wallet, and this has an impact on his points<br/>
    4: The Target is completed at the end of each month and the beginning of a new Target with a new month, the money is sent to the agencies on the 10th of each month<br/>
    5: The host agencies are received via App WhatsApp to send all the information required for registration at the beginning of each month`,
    desc1:
      'Cash rewards will be canceled for the following accounts: refunds after recharging, and cheating by one user using multiple fake accounts',
    desc2: '',
    tips: 'Notice',
    wait: 'Pending review',
    waitc: 'Please be patient and follow the application progress at any time',
    suc: 'Successful application',
    sucC: 'Congratulations on becoming a member of the host system program. You will be able to withdraw rubies.',
    fail: 'Application failed',
    failC: 'We are very sorry that your host system application failed for the following reasons:',
    apply: 'Apply',
    rapply: 'Re-apply',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'area number: +44', //me
    phomeNumber: 'phome number: 13650820118', //me,
    welcomeText: `Welcom to`,
    hostsystem: 'Host System',
    findanAgency: 'Find an Agency',
    createanAgency: 'Create an Agency',
    findText: 'Find and apply to join a Agency to become a Host',
    craeteText: 'Apply to create an Agency and invite others to join'
  },
  ar: {
    dear: 'عزيزي المستخدم',
    welcome:
      'مرحبا بكم في الانضمام إلى النظام المضيف، من خلال النظام المضيف، يمكنك الحصول على المكافآت النقدية المقابلة، والقواعد هي كما يلي',
    ruleContent: `1: لتفعيل وكالة مضيفين يجب أن لا يقل عدد المضيفين المراد تسجيلهم عن 15 مضيف ( يمكن أن يكون العدد أكثر ولا يمكن أن يكون أقل )<br/>
    2: يتم ترقية التارجت عن طريق تلقي هدايا الياقوت فقط<br/>
    3: هدايا الياقوت ينتج عنها ألماس يمكن استبدالها بكونزات.  كما يستطيع المضيف سحب الياقوت من نقاط التارجت ليستخدمها في محفظة الياقوت وهذا له تأثير على نقاطه<br/>
    4: يتم توقيف ترقية التارجت في نهاية كل شهر وبداية تارجت جديد مع الشهر الجديد ، و يتم إرسال الأموال إلى الوكالات في  10  من كل شهر<br/>
    5: يتم استقبال الوكالات المضيفة عبر WhatsApp لإرسال كافة المعلومات المطلوبة للتسجيل في بداية كل شهر`,
    desc1:
      'سيتم إلغاء المكافآت النقدية للحسابات التالية: استرداد بعد إعادة الشحن، مستخدم واحد باستخدام حسابات مزيفة متعددة للغش',
    desc2: '',
    tips: 'ملاحظة',
    wait: 'في انتظار مراجعة',
    waitc: 'يرجى الانتظار بصبر، يمكنك اتباع تقدم التطبيق',
    suc: 'تطبيق ناجح',
    sucC: 'تهانينا لأنك أصبحت عضوًا في برنامج النظام المضيف. ستتمكن من سحب الياقوت.',
    fail: 'فشل التطبيق',
    failC: 'أنا آسف جدًا لفشل تطبيق نظام المضيف ، والسبب:',
    apply: 'تطبيق',
    rapply: 'أعد التطبيق',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'رمز الدولة CN:+44', //me
    phomeNumber: 'جوال :13650820118',
    welcomeText: `مرحبا بكم في`,
    hostsystem: ' نظام المضيف',
    findanAgency: 'ابحث عن وكالة',
    createanAgency: 'إنشاء وكالة',
    findText: 'ابحث وتقدم للانضمام إلى وكالة لتصبح مضيفا',
    craeteText: 'تقدم بطلب لإنشاء وكالة ودعوة الآخرين للانضمام'
  },
  tr: {
    dear: 'Karşılıklı nakit ödüller alabileceğiniz Ajans Sistemine hoş geldiniz. ',
    welcome: 'Kurallar şunlardır:',
    ruleContent: `
    1. Ajans etkinleştirmek için, Kayıt edilecek yayıncı sayısı 15  kişiden az olmamalıdır (Sayı daha fazla olabilir, daha az olamaz)<br/> 2: Para Yakut hediyeleri alarak kazanılır<br/> 3: Yakut hediyeler paralarla değiştirilebilir ve coinse dönüştürülebilir Bu durum kotayı etkilemeyecektir. yayıncılar ayrıca yakutları  %50 olarak Dönüştürebilir ama bu kotadan düşürülecektir.<br/> 4: Kota her ayın sonunda tamamlanır ve yeni bir ay ile yeni bir Kota başlangıcında, Para, her ayın 10'unda ajanslara gönderilir.<br/> 5: Ajans sahipleri, her ayın başında yeni kayıt için gerekli id’leri göndermek için App WhatsApp ve yönetim  ekibi üzerinden alınır.<br/>`,
    desc1:
      'Nakit ödüller aşağıdaki hesaplar için iptal edilecektir: <br/>    - Çekim yaptıktan sonra geri İade alınması,<br/>    - Birden fazla sahte hesap kullanarak bir kullanıcı tarafından hile yapılması.',
    desc2: '',
    tips: 'Farkına varmak',
    wait: 'İnceleme bekleniyor',
    waitc: 'Lütfen sabırlı olun ve başvurunun ilerlemesini istediğiniz zaman takip edin',
    suc: 'Başarılı uygulama',
    sucC: 'Ana bilgisayar sistemi programına üye olduğunuz için tebrikler. Yakutları geri çekebileceksiniz.',
    fail: 'Uygulama başarısız oldu',
    failC: 'Ana bilgisayar sistemi uygulamanız aşağıdaki nedenlerden dolayı başarısız olduğu için çok üzgünüz:',
    apply: 'Uygulamak',
    rapply: 'Yeniden başvur',
    whatsapp: 'Whatsapp',
    areaNumber: '+44',
    phomeNumber: 'Telefon numarası:13650820118',
    welcomeText: `Ajans Sistemine`,
    hostsystem: 'Hoşgeldiniz',
    findanAgency: 'Bir Ajans Bul',
    createanAgency: 'Bir Ajans Oluşturun',
    findText: 'Yayıncı olmak için bir ajansa başvurun',
    craeteText: 'Bir Ajans oluşturmak için başvurun ve başkalarını katılmaya davet edin'
  },
  uz: {
    dear: 'Hurmatli foydalanuvchi',
    welcome:
      'Host tizimiga xush kelibsiz, bu orqali siz tegishli naqd pul mukofotlarini olishingiz mumkin. Qoidalar quyidagicha:',
    ruleContent: `1: Host agentligini faollashtirish uchun ro'yxatdan o'tadigan hostlar soni 15 tadan kam bo'lmasligi kerak (soni ko'proq bo'lishi mumkin, ammo kam bo'lmasligi kerak) <br/> 2: Pul rubin sovg'alarini qabul qilish orqali topiladi<br> 3: Rubin sovg'alari olmoslarga aylanadi, ular tangalar bilan almashilishi mumkin. Host rubinlarni o'z ballaridan yechib olib, rubin hamyonida ishlatishi mumkin, bu uning ballariga ta'sir qiladi<br/> 4: Maqsad har oy oxirida tugatiladi va yangi oyda yangi maqsad boshlanadi, pul har oyning 10-kunida agentliklarga yuboriladi<br/> 5: Host agentliklari har oy boshida ro'yxatdan o'tish uchun zarur bo'lgan barcha ma'lumotlarni yuborish uchun App WhatsApp orqali yuboriladi`,
    desc1:
      "Quyidagi hisoblar uchun naqd pul mukofotlari bekor qilinadi: to'lovdan keyin qaytarish, va bir foydalanuvchi tomonidan ko'plab soxta hisoblar bilan aldash",
    desc2: '',
    tips: "E'lon",
    wait: "Ko'rib chiqilmoqda",
    waitc: "Iltimos, sabrli bo'ling va iltimos, ariza jarayonini har doim kuzatib boring",
    suc: 'Ariza muvaffaqiyatli',
    sucC: "Host tizimi dasturiga a'zo bo'lishingiz bilan tabriklaymiz. Endi rubinlarni yechib olishingiz mumkin.",
    fail: 'Ariza muvaffaqiyatsiz',
    failC: "Kechirasiz, sizning host tizimi arizangiz quyidagi sabablarga ko'ra muvaffaqiyatsiz bo'ldi:",
    apply: 'Ariza berish',
    rapply: 'Qayta ariza berish',
    whatsapp: 'Whatsapp',
    areaNumber: 'Hudud raqami: +44',
    phomeNumber: 'Telefon raqami: 13650820118',
    welcomeText: 'Xush kelibsiz',
    hostsystem: 'Host tizimi',
    findanAgency: 'Agentlikni topish',
    createanAgency: 'Agentlik yaratish',
    findText: "Host bo'lish uchun agentlikka qo'shilish uchun topib, ariza bering",
    craeteText: "Agentlik yaratish uchun ariza bering va boshqalarni qo'shishga taklif qiling"
  },
  ru: {
    dear: 'Уважаемый пользователь',
    welcome:
      'Добро пожаловать в систему хостинга, через которую вы можете получить соответствующие денежные вознаграждения. Правила следующие:',
    ruleContent: `1: Для активации хост-агентства количество зарегистрированных хостов должно быть не менее 15 хостов (количество может быть больше, но не меньше) <br/> 2: Деньги зарабатываются получением подарков рубинов<br> 3: Рубиновые подарки преобразуются в алмазы, которые можно обменять на монеты. Хост также может вывести рубины из своих баллов и использовать их в рубиновом кошельке, что влияет на его баллы<br/> 4: Цель выполняется в конце каждого месяца и начинается новая цель с новым месяцем, деньги отправляются агентствам 10-го числа каждого месяца<br/> 5: Хост-агентства получают всю необходимую информацию для регистрации в начале каждого месяца через WhatsApp приложения"`,
    desc1:
      'Денежные вознаграждения будут отменены для следующих аккаунтов: возврат средств после пополнения и мошенничество с использованием нескольких поддельных аккаунтов одним пользователем',
    desc2: '',
    tips: 'Уведомление',
    wait: 'Ожидание проверки',
    waitc: 'Пожалуйста, будьте терпеливы и следите за процессом заявки в любое время',
    suc: 'Успешная заявка',
    sucC: 'Поздравляем с тем, что вы стали членом программы хост-системы. Теперь вы можете вывести рубины.',
    fail: 'Заявка не удалась',
    failC: 'К сожалению, ваша заявка в систему хостинга не была успешной по следующим причинам:',
    apply: 'Подать заявку',
    rapply: 'Переоформить заявку',
    whatsapp: 'Whatsapp',
    areaNumber: 'Код области: +44',
    phomeNumber: 'Телефонный номер: 13650820118',
    welcomeText: 'Добро пожаловать в',
    hostsystem: 'Система хостинга',
    findanAgency: 'Найти агентство',
    createanAgency: 'Создать агентство',
    findText: 'Найдите и подайте заявку на вступление в агентство, чтобы стать хостом',
    craeteText: 'Подайте заявку на создание агентства и пригласите других присоединиться'
  },
  fa: {
    dear: 'کاربر گرامی',
    welcome:
      'به سیستم میزبان خوش آمدید، از طریق این سیستم می‌توانید جوایز نقدی مربوطه را دریافت کنید. قوانین به شرح زیر است:',
    ruleContent: `1: برای فعال‌سازی یک آژانس میزبان، تعداد میزبان‌هایی که باید ثبت‌نام شوند باید حداقل 15 میزبان باشد (تعداد می‌تواند بیشتر باشد، اما نباید کمتر باشد) <br/> 2: پول از طریق دریافت هدایای روبین به دست می‌آید<br> 3: هدایای روبین به الماس تبدیل می‌شوند که می‌توان آنها را با سکه‌ها تعویض کرد. میزبان همچنین می‌تواند روبین‌ها را از امتیازات خود برداشت کرده و از آنها در کیف پول روبین استفاده کند، که این تأثیر بر امتیازات او خواهد داشت<br/> 4: هدف در پایان هر ماه تکمیل می‌شود و هدف جدید با شروع ماه جدید آغاز می‌شود، پول هر ماه در 10 امین روز ماه به آژانس‌ها ارسال می‌شود<br/> 5: آژانس‌های میزبان از طریق WhatsApp اپلیکیشن اطلاعات مورد نیاز برای ثبت‌نام را در ابتدای هر ماه دریافت می‌کنند`,
    desc1:
      'جوایز نقدی برای حساب‌های زیر لغو خواهد شد: بازپرداخت‌ها پس از شارژ و تقلب توسط یک کاربر که از چند حساب جعلی استفاده می‌کند',
    desc2: '',
    tips: 'اطلاعیه',
    wait: 'در حال بررسی',
    waitc: 'لطفاً صبور باشید و در هر زمان روند درخواست را دنبال کنید',
    suc: 'درخواست موفقیت‌آمیز',
    sucC: 'تبریک می‌گوییم که به عضویت برنامه سیستم میزبان درآمدید. اکنون می‌توانید روبین‌ها را برداشت کنید.',
    fail: 'درخواست ناموفق',
    failC: 'با پوزش، درخواست شما برای سیستم میزبان به دلایل زیر ناموفق بود:',
    apply: 'درخواست بدهید',
    rapply: 'دوباره درخواست دهید',
    whatsapp: 'Whatsapp',
    areaNumber: 'کد منطقه: +44',
    phomeNumber: 'شماره تلفن: 13650820118',
    welcomeText: 'خوش آمدید به',
    hostsystem: 'سیستم میزبان',
    findanAgency: 'یک آژانس پیدا کنید',
    createanAgency: 'یک آژانس ایجاد کنید',
    findText: 'برای پیوستن به یک آژانس و تبدیل شدن به میزبان، جستجو و درخواست دهید',
    craeteText: 'برای ایجاد یک آژانس درخواست دهید و دیگران را به پیوستن دعوت کنید'
  },
  pt: {
    dear: 'Caro usuário',
    welcome:
      'Bem-vindo ao Sistema de Hospedagem, através do qual você pode receber recompensas em dinheiro correspondentes. As regras são as seguintes:',
    ruleContent: `1: Para ativar uma agência de hospedagem, o número de hosts a serem registrados deve ser no mínimo 15 hosts (o número pode ser maior, mas não pode ser menor) <br/> 2: O dinheiro é ganho recebendo presentes de Rubis <br /> 3: Os presentes de rubis resultam em diamantes que podem ser trocados por moedas. O host também pode retirar rubis de seus pontos para usá-los na carteira de rubis, e isso tem impacto nos seus pontos <br/> 4: O objetivo é concluído no final de cada mês e o início de um novo objetivo com um novo mês, o dinheiro é enviado para as agências no dia 10 de cada mês <br/> 5: As agências de hospedagem recebem via WhatsApp no aplicativo para enviar todas as informações necessárias para o registro no início de cada mês`,
    desc1:
      'As recompensas em dinheiro serão canceladas para as seguintes contas: reembolsos após recarga e fraude por um usuário usando várias contas falsas',
    desc2: '',
    tips: 'Aviso',
    wait: 'Aguardando revisão',
    waitc: 'Por favor, seja paciente e acompanhe o progresso da aplicação a qualquer momento',
    suc: 'Aplicação bem-sucedida',
    sucC: 'Parabéns por se tornar um membro do programa do sistema de hospedagem. Você poderá retirar rubis.',
    fail: 'Aplicação falhou',
    failC: 'Lamentamos muito que sua aplicação para o sistema de hospedagem tenha falhado pelos seguintes motivos:',
    apply: 'Aplicar',
    rapply: 'Reaplicar',
    whatsapp: 'Whatsapp',
    areaNumber: 'Número da área: +44',
    phomeNumber: 'Número de telefone: 13650820118',
    welcomeText: 'Bem-vindo ao',
    hostsystem: 'Sistema de Hospedagem',
    findanAgency: 'Encontrar uma Agência',
    createanAgency: 'Criar uma Agência',
    findText: 'Encontre e se inscreva para se tornar um Host em uma Agência',
    craeteText: 'Inscreva-se para criar uma Agência e convide outros a se juntar'
  },
  id: {
    dear: 'Pengguna yang terhormat',
    welcome:
      'Selamat datang di Sistem Host, melalui mana Anda dapat menerima hadiah uang tunai yang sesuai. Aturan adalah sebagai berikut:',
    ruleContent: `1: Untuk mengaktifkan agen host, jumlah host yang harus didaftarkan tidak boleh kurang dari 15 host (jumlahnya bisa lebih banyak, tetapi tidak boleh lebih sedikit) <br/> 2: Uang diperoleh dengan menerima hadiah Rubi<br> 3: Hadiah rubi menghasilkan berlian yang dapat ditukar dengan koin. Host juga dapat menarik rubi dari poinnya untuk menggunakannya di dompet rubi, dan ini berdampak pada poinnya<br/> 4: Target diselesaikan di akhir setiap bulan dan dimulai dengan target baru di bulan baru, uang dikirim ke agen pada tanggal 10 setiap bulan<br/> 5: Agen host diterima melalui WhatsApp aplikasi untuk mengirimkan semua informasi yang diperlukan untuk registrasi di awal setiap bulan`,
    desc1:
      'Hadiah uang tunai akan dibatalkan untuk akun berikut: pengembalian dana setelah pengisian ulang, dan penipuan oleh satu pengguna menggunakan beberapa akun palsu',
    desc2: '',
    tips: 'Pemberitahuan',
    wait: 'Menunggu tinjauan',
    waitc: 'Harap bersabar dan ikuti kemajuan aplikasi kapan saja',
    suc: 'Aplikasi berhasil',
    sucC: 'Selamat telah menjadi anggota program sistem host. Anda dapat menarik rubi.',
    fail: 'Aplikasi gagal',
    failC: 'Kami sangat menyesal aplikasi sistem host Anda gagal karena alasan berikut:',
    apply: 'Ajukan',
    rapply: 'Ajukan ulang',
    whatsapp: 'Whatsapp',
    areaNumber: 'Nomor area: +44',
    phomeNumber: 'Nomor telepon: 13650820118',
    welcomeText: 'Selamat datang di',
    hostsystem: 'Sistem Host',
    findanAgency: 'Temukan Agen',
    createanAgency: 'Buat Agen',
    findText: 'Cari dan ajukan untuk bergabung dengan Agen untuk menjadi Host',
    craeteText: 'Ajukan untuk membuat Agen dan ajak orang lain untuk bergabung'
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-join/lang.js